import {
  PriceListUpdateDerivedRequestType,
  PriceListUpdateDerivedResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListUpdateDerived = (priceListId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceListUpdateDerivedRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `price-lists/${priceListId}/derived`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as PriceListUpdateDerivedResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers, priceListId],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.ProductAssignment],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.ProductPriceTiersLegacy],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.ProductPriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
